import React from "react";

import search from "../../images/icons/search.png"
import events from "../../images/icons/events.png"
import update from "../../images/icons/update.png"
 
import { BsArrowUp, BsChevronDoubleRight, BsChevronRight } from "react-icons/bs";

import { Link } from "react-router-dom"; 

const Users = [
    {
        id: 100,
        selected: false,
        wallboxSerial: "POJ-103949543129",
        FirmwareVersion: "V 0.73a",
        Dateinstalled: "2021 - 10 - 26",
        Functions: ['Solar Überschussladen', 'LTE', 'Open API', 'Admin Tool', 'Abrechnung', 'Lastmanagement'],
        Owner: "Julian Leudesdorff",
        Status: "Running", 
    },
    {
        id: 101,
        selected: false,
        wallboxSerial: "POJ-103949543129",
        FirmwareVersion: "V 0.73a",
        Dateinstalled: "2021 - 10 - 26",
        Functions: ['Solar Überschussladen', 'LTE', 'Open API', 'Admin Tool'],
        Owner: "Jonas Moßler",
        Status: "Running", 
    },
    {
        id: 102,
        selected: false,
        wallboxSerial: "POJ-103949543129",
        FirmwareVersion: "V 0.73a",
        Dateinstalled: "2021 - 10 - 26",
        Functions: ['Solar Überschussladen', 'LTE', 'Open API', 'Lastmanagement'],
        Owner: "Jonas Moßler",
        Status: "Running", 
    },
    {
        id: 103,
        selected: false,
        wallboxSerial: "POJ-103949543129",
        FirmwareVersion: "V 0.73a",
        Dateinstalled: "2021 - 10 - 26",
        Functions: ['Solar Überschussladen', 'LTE', 'Open API'],
        Owner: "Jonas Moßler",
        Status: "Running", 
        
    },
    {
        id: 104,
        selected: false,
        wallboxSerial: "POJ-103949543129",
        FirmwareVersion: "V 0.73a",
        Dateinstalled: "2021 - 10 - 26",
        Functions: ['Solar Überschussladen', 'LTE', 'Open API', 'Admin Tool'],
        Owner: "Jonas Moßler",
        Status: "Running", 
    },
    {
        id: 105,
        selected: false,
        wallboxSerial: "POJ-103949543129",
        FirmwareVersion: "V 0.73a",
        Dateinstalled: "2021 - 10 - 26",
        Functions: ['Solar Überschussladen', 'LTE', 'Open API', 'Lastmanagement'],
        Owner: "Jonas Moßler",
        Status: "Running", 
    },
    {
        id: 106,
        selected: false,
        wallboxSerial: "POJ-103949543129",
        FirmwareVersion: "V 0.73a",
        Dateinstalled: "2021 - 10 - 26",
        Functions: ['Solar Überschussladen', 'LTE', 'Open API'],
        Owner: "Jonas Moßler",
        Status: "Running", 
        
    },
    {
        id: 107,
        selected: false,
        wallboxSerial: "POJ-103949543129",
        FirmwareVersion: "V 0.73a",
        Dateinstalled: "2021 - 10 - 26",
        Functions: ['Solar Überschussladen', 'LTE', 'Open API'],
        Owner: "Jonas Moßler",
        Status: "Running", 
        
    },
    {
        id: 108,
        selected: false,
        wallboxSerial: "POJ-103949543129",
        FirmwareVersion: "V 0.73a",
        Dateinstalled: "2021 - 10 - 26",
        Functions: ['Solar Überschussladen', 'LTE', 'Open API', 'Admin Tool'],
        Owner: "Jonas Moßler",
        Status: "Running", 
    },
    {
        id: 109,
        selected: false,
        wallboxSerial: "POJ-103949543129",
        FirmwareVersion: "V 0.73a",
        Dateinstalled: "2021 - 10 - 26",
        Functions: ['Solar Überschussladen', 'LTE', 'Open API', 'Lastmanagement'],
        Owner: "Jonas Moßler",
        Status: "Running", 
    },
    {
        id: 110,
        selected: false,
        wallboxSerial: "POJ-103949543129",
        FirmwareVersion: "V 0.73a",
        Dateinstalled: "2021 - 10 - 26",
        Functions: ['Solar Überschussladen', 'LTE', 'Open API'],
        Owner: "Jonas Moßler",
        Status: "Running", 
        
    },
    {
        id: 111,
        selected: false,
        wallboxSerial: "POJ-103949543129",
        FirmwareVersion: "V 0.73a",
        Dateinstalled: "2021 - 10 - 26",
        Functions: ['Solar Überschussladen', 'LTE', 'Open API'],
        Owner: "Jonas Moßler",
        Status: "Running", 
        
    },
    {
        id: 112,
        selected: false,
        wallboxSerial: "POJ-103949543129",
        FirmwareVersion: "V 0.73a",
        Dateinstalled: "2021 - 10 - 26",
        Functions: ['Solar Überschussladen', 'LTE', 'Open API', 'Lastmanagement'],
        Owner: "Jonas Moßler",
        Status: "Running", 
    },
    {
        id: 113,
        selected: false,
        wallboxSerial: "POJ-103949543129",
        FirmwareVersion: "V 0.73a",
        Dateinstalled: "2021 - 10 - 26",
        Functions: ['Solar Überschussladen', 'LTE', 'Open API'],
        Owner: "Jonas Moßler",
        Status: "Running", 
        
    },

];

// Sorting function
const sortedList = (data, order, item) => {
    if (order === 'up') {
        return data.sort((a, b) => (a[item] ? 1 : -1));
    }
    if (order === 'down') {
        return data.sort((a, b) => (a[item] ? -1 : 1));
    }
}

class WallBoxTable extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            List: Users,
            MasterChecked: false,
            SelectedList: [],
            show: false,
            currentSort: 'up'
        };
    }

    handleModal() {
        this.setState({ show: !this.state.show })
    }

    // Select/ UnSelect Table rows
    onMasterCheck(e) {
        let tempList = this.state.List;
        // Check/ UnCheck All Items
        tempList.map((user) => (user.selected = e.target.checked));

        //Update State
        this.setState({
            MasterChecked: e.target.checked,
            List: tempList,
            SelectedList: this.state.List.filter((e) => e.selected),
        });
    }

    // Update List Item's state and Master Checkbox State
    onItemCheck(e, item) {
        let tempList = this.state.List;
        tempList.map((user) => {
            if (user.id === item.id) {
                user.selected = e.target.checked;
            }
            return user;
        });

        //To Control Master Checkbox State
        const totalItems = this.state.List.length;
        const totalCheckedItems = tempList.filter((e) => e.selected).length;

        // Update State
        this.setState({
            MasterChecked: totalItems === totalCheckedItems,
            List: tempList,
            SelectedList: this.state.List.filter((e) => e.selected),
        });
    }

    // Event to get selected rows(Optional)
    getSelectedRows() {
        this.setState({
            SelectedList: this.state.List.filter((e) => e.selected),
        });
    }

    onSortChange = () => {
        const { currentSort } = this.state;
        let nextSort;

        if (currentSort === 'down') nextSort = 'up';
        else if (currentSort === 'up') nextSort = 'down';

        this.setState({
            currentSort: nextSort,
        });

    };

    render() {
        return (
            <>
                <div className="table-componet">
                    <div className="row">
                        <div className="col-md-12"> 
                            <div className="tab__content"> 
                                <table className="table box-table">
                                    <thead>
                                        <tr>
                                            <th scope="col">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input"
                                                    checked={this.state.MasterChecked}
                                                    id="mastercheck"
                                                    onChange={(e) => this.onMasterCheck(e)}
                                                />
                                            </th>
                                            <th scope="col">ID</th>
                                            <th scope="col" className="serialT">Wallbox Serial</th>
                                            <th scope="col" className="FirmwareT">Firmware Version</th>
                                            <th onClick={this.onSortChange} scope="col" className="id">
                                                <span className="d-installed">Date installed  <BsArrowUp/></span>
                                            </th>
                                            <th scope="col" className="functionsT">Functions </th>
                                            <th scope="col" className="ownerT">Owner</th>
                                            <th scope="col" className="statusT">Status</th>
                                            <th scope="col" className="actionsT">Actions</th> 
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {sortedList(this.state.List, this.state.currentSort, 'id').map((user) => (
                                            <tr key={user.id} className={user.selected ? "selected" : ""}>
                                                <th scope="row">
                                                    <input
                                                        type="checkbox"
                                                        checked={user.selected}
                                                        className="form-check-input"
                                                        id="rowcheck{user.id}"
                                                        onChange={(e) => this.onItemCheck(e, user)}
                                                    />
                                                </th>
                                                <td><span>{user.id}</span></td>
                                                <td className="wallboxSerial"><span><Link to="/wallbox_single">{user.wallboxSerial}</Link></span></td>
                                                <td className="FirmwareVersion"><span>{user.FirmwareVersion}</span></td>
                                                <td className="Dateinstalled"><span>{user.Dateinstalled}</span></td>
                                                <td className="Functions">
                                                    <span>
                                                        {user.Functions.slice().map((sold) => (
                                                            <button className={sold}>{sold}</button>
                                                        ))}
                                                    </span>
                                                </td>
                                                <td className="Owner"><span>{user.Owner}</span></td>
                                                <td className="Stat"><span className={user.Status}>{user.Status}</span></td>
                                                <td className="Actions">
                                                    <span>
                                                        <button><img src={events} /> Events</button>
                                                        <button><img src={update} /> Update</button>
                                                        <button><img src={search} /></button>
                                                    </span>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div className="pagination-content">
                        <ul> 
                            <li>1</li>
                            <li className="active">2</li>
                            <li>3</li>
                            <li>4</li>
                            <li><BsChevronDoubleRight /></li> 
                        </ul>
                        <div className="pageRight">
                            <span>Showing 20 of 320 items</span>
                        </div>
                    </div>
                </div>

            </>
        );
    }
}

export default WallBoxTable;